import PlanningWorkOrderApi from '@infrastructure/planning-api';
import { createAsyncThunk } from '@reduxjs/toolkit';
import { getErrorPayload } from '@application/common/helpers/api-helper';
export const getAllSmallJobWorkOrderAsync = createAsyncThunk('workorder/GetAllSmallJobWorkOrders', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await PlanningWorkOrderApi.getAllSmallJobWorkOrderByLocationId(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getWorkshopLocationAsync = createAsyncThunk('workshoplocation', async (_, { rejectWithValue }) => {
    try {
        const response = await PlanningWorkOrderApi.getWorkshopLocation();
        return response.data;
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllWorkOrderWithoutTechnicianAsync = createAsyncThunk('Planning/GetAllWorkOrderWithoutTechnician', async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await PlanningWorkOrderApi.getAllWorkOrderWithoutTechnicianByLocationId(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
export const getAllTechniciansWithWorkordersAsync = createAsyncThunk(`Planning/GetAllTechniciansWithWorkorders`, async (request, { rejectWithValue, fulfillWithValue }) => {
    try {
        const response = await PlanningWorkOrderApi.getAllTechniciansWithWorkordersbyLocationId(request);
        return fulfillWithValue(response.data);
    }
    catch (error) {
        return rejectWithValue(getErrorPayload(error));
    }
});
